import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { UnitPricing as UnitPricingType } from 'src/api/FiretrolApiClient';
import { useUnitPricing } from 'src/api/queries/unitPricing/useUnitPricing';
import {
  useTable,
  useTableState,
} from 'src/design/organisms/DataTable/useTable';
import { useTableExports } from 'src/design/organisms/useTableExports';

export const UnitPricing: React.FC = () => {
  const { data, isLoading, isFetching, isError } = useUnitPricing();
  const rows = React.useMemo(() => data ?? [], [data]);

  const getColumns = React.useCallback((): MRT_ColumnDef<UnitPricingType>[] => {
    return [
      {
        accessorKey: 'description',
        header: 'Description',
        size: 200,
      },
      {
        accessorKey: 'pricing',
        header: 'Pricing',
        size: 200,
      },
      {
        accessorKey: 'bulkRate',
        header: 'Bulk Rate',
        size: 200,
      },
    ];
  }, []);

  const columns = useMemo(() => getColumns(), [getColumns]);

  const tableState = useTableState({
    identifier: 'unit-pricing',
    columns: columns,
    defaultSorting: [{ id: 'description', desc: false }],
  });

  const tableExports = useTableExports<UnitPricingType>(
    'unit-pricing',
    (data) => {
      return data.map((item) => ({
        ['Description']: item.description,
        ['Pricing']: item.pricing,
        ['Bulk Rate']: item.bulkRate,
      }));
    },
  );

  const { table } = useTable({
    ...tableState,
    tableOptions: {
      enableRowActions: false,
      enableClickToCopy: false,
      columns: columns,
      data: rows,
      manualPagination: false,
      manualSorting: false,
      manualFiltering: false,
    },
    getRowId: (row) => String(row.id),
    totalCount: rows.length,
    isLoading,
    isFetching,
    isError,
    ...tableExports,
  });

  return (
    <div style={{ height: 600, width: '100%', backgroundColor: '#fff' }}>
      {table}
    </div>
  );
};
